import { type TFunction } from 'i18next';
import * as yup from 'yup';

const loginSchemaConstructor = (t: TFunction) =>
  yup.object().shape({
    username: yup.string().required(
      t('namespaces:errors:required', {
        name: t('namespaces:properties:username'),
      }),
    ),
    password: yup.string().required(
      t('namespaces:errors:required', {
        name: t('namespaces:properties:password'),
      }),
    ),
  });

export { loginSchemaConstructor };
